// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon, { ICON_SIZE_16 } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `MenuBaseItem` component.
 * @since 0.0.60
 */
const MenuBaseItem = _ref => {
  let {
    className,
    children,
    icon,
    label,
    component: Component = 'div',
    baseClassName = `${CLS_PREFIX}menu__base-item`,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs(Component, {
    className: classNames(baseClassName, className),
    ...props,
    children: [/*#__PURE__*/_jsx("div", {
      className: `${baseClassName}-icon`,
      children: Icon.create(icon, {
        size: ICON_SIZE_16
      })
    }), /*#__PURE__*/_jsx("div", {
      className: `${baseClassName}-content`,
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: `${baseClassName}-label`,
      children: label
    })]
  });
};
export default MenuBaseItem;